import { useQuery } from '@tanstack/react-query';
import { apiClinicList } from 'lib/api/firebase/apis/apis';
import { Clinic } from 'lib/documents/clinic';

export function useGetOrganizations() {
  return useQuery<Clinic[], Error>({
    queryKey: ['organizations'],
    queryFn: () => apiClinicList().then(_ => _.data.organisations)
  });
}
